"use client"
/* */
import { jsx, jsxs } from 'react/jsx-runtime';
import 'react';
import styles from './Modal.module.scss.mjs';
import clsx from 'clsx';
import '../../lib/propsContext/propsContext.mjs';
import '../../lib/viewComponentContext/viewComponentContext.mjs';
import { PropsContextProvider } from '../../lib/propsContext/PropsContextProvider.mjs';
import { TunnelProvider, TunnelExit } from '@mittwald/react-tunnel';
import { flowComponent } from '../../lib/componentFactory/flowComponent.mjs';
import { Overlay } from '../Overlay/Overlay.mjs';
import { Action } from '../Action/Action.mjs';
import '@tabler/icons-react';
import '../Icon/Icon.mjs';
import { IconClose } from '../Icon/components/icons/IconClose.mjs';
import HeaderView from '../../views/HeaderView.mjs';
import ButtonView from '../../views/ButtonView.mjs';

const Modal = flowComponent("Modal", (props) => {
  const {
    size = "s",
    offCanvas,
    controller,
    children,
    ref,
    className,
    offCanvasOrientation = "right",
    ...rest
  } = props;
  const rootClassName = clsx(
    offCanvas ? styles.offCanvas : styles.modal,
    styles[`size-${size}`],
    styles[offCanvasOrientation],
    className
  );
  const propsContext = {
    Content: {
      className: styles.content,
      Section: {
        Heading: {
          level: 3
        },
        Header: {
          Heading: {
            level: 3
          }
        }
      }
    },
    ColumnLayout: {
      l: [2, 1],
      m: [1],
      className: styles.columnLayout,
      Section: {
        Heading: {
          level: 3
        }
      },
      AccentBox: { className: styles.accentBox, color: "neutral" }
    },
    Heading: {
      level: 2,
      slot: "title",
      tunnelId: "heading"
    },
    ActionGroup: {
      className: styles.actionGroup,
      spacing: "m"
    }
  };
  return /* @__PURE__ */ jsx(
    Overlay,
    {
      className: rootClassName,
      controller,
      ref,
      ...rest,
      children: /* @__PURE__ */ jsx(PropsContextProvider, { props: propsContext, children: /* @__PURE__ */ jsxs(TunnelProvider, { children: [
        /* @__PURE__ */ jsxs(HeaderView, { className: styles.header, children: [
          /* @__PURE__ */ jsx(TunnelExit, { id: "heading" }),
          /* @__PURE__ */ jsx(Action, { closeOverlay: "Modal", children: /* @__PURE__ */ jsx(
            ButtonView,
            {
              variant: "plain",
              color: "secondary",
              className: styles.closeButton,
              onPress: controller?.close,
              children: /* @__PURE__ */ jsx(IconClose, {})
            }
          ) })
        ] }),
        children
      ] }) })
    }
  );
});

export { Modal, Modal as default };
//# sourceMappingURL=Modal.mjs.map
